import React from 'react'
import styles from './Avatar.module.sass'
import { UtenteType } from '@utils/types'
import Tooltip from '../Tooltip/Tooltip'
import { cn } from '@utils/safeTs'


interface Props {
  id?: string
  utente?: UtenteType
  variant?: 'chat' | 'incaricato'
  size?: 'md' | 'sm'
  showTooltip?: boolean
  dialog?: boolean
  className?: string
}

const Avatar = (props: Props) => {

  const { 
    id,
    utente,
    variant = 'chat',
    size = 'md',
    showTooltip = true,
    dialog = false,
    className = '',
  } = props

  const hue = React.useMemo(() => {
    if (!utente) return 0
    const fullName = `${utente.nome ?? ''}${utente.cognome ?? ''}`
    return fullName.split('').reduce((res, c) => res += c.charCodeAt(0), 0) % 180
  }, [utente])

  const saturation = variant === 'incaricato' ? 30 : 70
  const lightness = variant === 'incaricato' ? 80 : 80

  const getContent = () => (
    <span className={styles.content} style={{ background: `hsl(${hue} ${saturation}% ${lightness}%)`}} aria-label={[utente.nome, utente.cognome].join(" ")}>
      {`${utente.nome?.[0]}${utente.cognome?.[0]}` || '?'}
    </span>
  )

  return utente ? (
    <div className={cn(styles.root, styles[`root--${variant}`], styles[`root--${size}`], className)}>
      {showTooltip ? (
        <Tooltip id={`${id}_tooltip`} label={`${utente.nome} ${utente.cognome}`} pos={'top'} dialog={dialog}>
          {getContent()}
        </Tooltip>
      ) : getContent()}
    </div>
  ) : <></>
}

export default Avatar
